import React from 'react';
import ReactDOM from 'react-dom';
import { QueryClient, QueryClientProvider } from 'react-query';
import { BrowserRouter } from 'react-router-dom';
import App from './app/App';
import * as serviceWorker from './serviceWorker';
import { ThemeProvider } from './app/context/ThemeContext';
import "./assets/styles/dark-theme.css"
import { SideBarProvider } from './app/context/SideBarContext';

const queryClient = new QueryClient({
    defaultOptions: {
        queries: {
            refetchOnWindowFocus: false,
            retry: false,
        },
    },
});

{/* CHANGE THE BASENAME TO SUBDIRECTIORY WHERE YOU WANT TO REDIRECT THE PAGE
    IT WILL APPEND THE basename WITH EVERY ROUTE PATH SO, REDIRECT ISSUE WILL NOT BE THERE 
*/}
ReactDOM.render(
    <BrowserRouter basename='/'> {/* Comment this line and Uncomment above line at the time of build */}
        <QueryClientProvider client={queryClient}>
            {/*custom theme context provider*/}
            <ThemeProvider>
                <SideBarProvider>
                    <App />
                </SideBarProvider>
            </ThemeProvider>
        </QueryClientProvider>
    </BrowserRouter>
    , document.getElementById('root'));

serviceWorker.unregister();